import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useLanguage } from '../context/LanguageContext';

const { FiBriefcase, FiBookOpen, FiCamera, FiCpu } = FiIcons;

const AboutExpertise = () => {
  const { lang } = useLanguage();
  const isSpanish = lang === 'es';

  const expertise = isSpanish
    ? [
        {
          title: 'Más de 10 años en ventas B2B',
          description:
            'Entiendo la psicología del cliente, las objeciones, el valor y lo que realmente mueve una conversación hacia una decisión.',
          icon: FiBriefcase
        },
        {
          title: 'Diseño instruccional',
          description:
            'Sé convertir ideas complicadas en una comunicación sencilla y convincente.',
          icon: FiBookOpen
        },
        {
          title: 'Foto y vídeo',
          description:
            'Creo contenido visual profesional que hace que tu experiencia sea más fácil de creer.',
          icon: FiCamera
        },
        {
          title: 'IA y automatización',
          description:
            'Construyo sistemas sencillos que captan, cualifican y hacen seguimiento de leads sin añadir más trabajo a tu día.',
          icon: FiCpu
        }
      ]
    : [
        {
          title: '10+ years in B2B Sales',
          description:
            'I understand customer psychology, objections, value and what actually moves a conversation toward a decision.',
          icon: FiBriefcase
        },
        {
          title: 'Instructional Design',
          description:
            'I know how to turn complicated ideas into simple, compelling communication.',
          icon: FiBookOpen
        },
        {
          title: 'Photo & Video',
          description:
            'I create professional visual content that makes your expertise easier to trust.',
          icon: FiCamera
        },
        {
          title: 'AI & Automation',
          description:
            'I build simple systems that capture, qualify and follow up with leads without adding more work to your day.',
          icon: FiCpu
        }
      ];

  return (
    <section className="mb-28">
      <div className="max-w-3xl mb-12">
        <p className="text-orange-500 font-black text-xs tracking-[0.24em] uppercase mb-5">
          {isSpanish ? 'Lo que aporto' : 'What I bring to the table'}
        </p>
        <h2 className="text-4xl md:text-5xl font-black tracking-tighter text-white leading-[0.95]">
          {isSpanish
            ? 'Un camino más claro de la atención al cliente.'
            : 'A clearer path from attention to customer.'}
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {expertise.map((item, index) => (
          <motion.div
            key={item.title}
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.08 }}
            className="p-8 bg-zinc-900 border border-white/5 rounded-3xl hover:border-orange-500/30 transition-colors"
          >
            <div className="w-12 h-12 flex items-center justify-center bg-orange-500/10 border border-orange-500/20 rounded-xl mb-6">
              <SafeIcon icon={item.icon} className="text-2xl text-orange-500" />
            </div>
            <h3 className="text-xl font-black text-white mb-3">{item.title}</h3>
            <p className="text-zinc-400 leading-relaxed">{item.description}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default AboutExpertise;